/* jshint esnext: true */
import { Controller } from '@hotwired/stimulus';

// スコープ内の [data-bs-toggle="tooltip"] 要素に Bootstrap5 の Tooltip を初期化する。
// アプリの JS は BS5 だが、旧来のグローバル初期化 (main.js の
// jQuery `$.fn.tooltip`) は BS5 で廃止され動作しない。そのため個別に
// bootstrap.Tooltip を生成する。bootstrap 未ロード環境ではネイティブの
// title 属性で理由が表示される (graceful degradation)ため、ここで
// 何もしなくてもツールチップ自体は失われない。
// 先例: lias_comma_controller の addTooltip。
export default class extends Controller {
  connect() {
    this.tooltips = [];
    const bs = window.bootstrap;

    if (!bs || !bs.Tooltip) return;

    this.element.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
      this.tooltips.push(bs.Tooltip.getOrCreateInstance(el));
    });
  }

  disconnect() {
    if (!this.tooltips) return;

    this.tooltips.forEach((tooltip) => tooltip.dispose());
    this.tooltips = [];
  }
}
